<template>
    <div class="sign-up">
        <h4>{{ $t("messages.login.createAccount") }}</h4>
        <form @submit.prevent="submit">
            <div class="form-group" :class="{ 'form-group--error': $v.form.email.$error }">
                <input class="form-control" :placeholder="$t('messages.login.email')" v-model.trim="$v.form.email.$model" />
            </div>
            <div v-if="$v.form.$error">
                <div class="error" v-if="!$v.form.email.required">{{ $t('messages.login.error.required') }}</div>
                <div class="error" v-if="!$v.form.email.email">{{ $t('messages.login.error.mailNotValid') }}</div>
            </div>

                <div class="form-group" :class="{ 'form-group--error': $v.form.name.$error }">
     
                    <input class="form-control" :placeholder="$t('messages.login.name')" v-model.trim="$v.form.name.$model"/>
                </div>
                <div v-if="$v.form.$error">
                    <div class="error" v-if="!$v.form.name.required">{{ $t('messages.login.error.required') }}</div>
                    <div class="error" v-if="!$v.form.name.minLength">{{ $t('messages.login.error.minLength', { field: $t("messages.login.name"), value: $v.form.name.$params.minLength.min }) }}</div>
                </div>

                <div class="form-group" :class="{ 'form-group--error': $v.form.country.$error }">
                    <b-form-select class="form-control"  v-model="$v.form.country.$model" :options="countries" :placeholder="$t('messages.login.country')"/>
                </div>
                <div v-if="$v.form.$error">
                    <div class="error" v-if="!$v.form.country.required">{{ $t('messages.login.error.required') }}</div>
                </div>

                <div class="form-group" :class="{ 'form-group--error': $v.form.password.$error }">
                    <input class="form-control" :placeholder="$t('messages.login.password')" type="password" v-model.trim="$v.form.password.$model"/>
                </div>
                <div v-if="$v.form.$error">
                    <div class="error" v-if="!$v.form.password.required">{{ $t('messages.login.error.required') }}</div>
                    <!-- <div class="error" v-if="!$v.form.password.minLength">{{ $t('messages.login.error.minLength', { field: $t("messages.login.password"), value: $v.form.password.$params.minLength.min }) }} </div>
                    <div class="error" v-if="!$v.form.password.maxLength">{{ $t('messages.login.error.maxLength', { field: $t("messages.login.password"), value: $v.form.password.$params.maxLength.max }) }} </div> -->
                    <div class="error" v-if="!$v.form.password.isPasswordSafe">{{ $t('messages.login.error.notSafe', { field: $t("messages.login.password"), value: $v.form.password.$params.isPasswordSafe }) }} </div>
                </div>
            
                <div class="form-group" :class="{ 'form-group--error': $v.form.repeatPassword.$error }">
                    <input class="form-control"  :placeholder="$t('messages.login.repeatPassword')" type="password" v-model.lazy="$v.form.repeatPassword.$model" data-vv-validate-on="blur" />
                </div>
                <div v-if="$v.form.$error">
                    <div class="error" v-if="!$v.form.repeatPassword.sameAsPassword"> {{ $t('messages.login.error.passwordIdentical') }}</div>
                </div>

                <div class="form-group">
                    <b-form-select class="form-control"  v-model="form.lang" :options="options"/>
                </div>

                <div class="form-group" :class="{ 'form-group--error': $v.form.terms.$error }" >
                       <b-form-checkbox class="form-control"
                        id="checkbox-1"
                        v-model="$v.form.terms.$model"
                        name="checkbox-1"
                        value=true
                        unchecked-value="false"
                        >
                           {{ $t("messages.gdpr.accept") }} <span @click="showTerms"><icon name="info-circle"> </icon></span>
                        </b-form-checkbox>
                </div>
                <div v-if="$v.form.$error">
                    <div class="error" v-if="!$v.form.terms.sameAs"> {{ $t('messages.login.error.terms') }}</div>
                </div>
                        
                <vue-recaptcha 
                    sitekey="6LccKH0UAAAAAFP2j4TmFl3UF5_j57eldq12H-or"
                    v-model="form.recaptcha"
                    @verify="onCapchaVerify"
                    style="margin-top:10px;overflow:hidden;"
                    >
                </vue-recaptcha>
                <div v-if="$v.form.$error && !form.recaptcha || form.recaptchaError">
                    <div class="error"> {{ $t('messages.login.error.required') }}</div>
                </div>
                <el-col>
                    <b-button class="remember" size="sm" variant="link" v-on:click="callLogin"> {{ $t("messages.login.backToLogin") }} </b-button>
                    <button type="submit" class="button" style="margin-top:15px">{{ $t("messages.login.request") }}</button>
                </el-col>
        </form>

    </div>
</template>

<script>
const fb = require('../firebaseConfig.js')
import {required,email, sameAs, minLength, maxLength} from 'vuelidate/lib/validators';
import VueRecaptcha from 'vue-recaptcha';
import { mapState } from 'vuex'

const reg = /^(?=.*[A-Z])(?=.*[!@#$%^&*(),.?":{}|<>[\]\/\\-]).{8,25}$/;
const isPasswordSafe = (value) =>  (reg.test(value))

export default {
    name: 'signUp',
    components: {
        VueRecaptcha,
    },
    props: {
        actionCodeSettings: {},
        company: null
    },
    created(){
      this.setCountries()
    },
    computed: {
        countriesList: function () {
            var index =  this.languages.map((o) => o.code).indexOf(this.$i18n.locale);
            this.$v.form.country.$model = (this.languages[index].code !='en') ? this.languages[index].code.toUpperCase() : 'ES'
            return this.languages[index].countries;
        },
        ...mapState(['languages'])
    }, 
    watch: {
      "$i18n.locale": function(oldV, newV) {
        this.setCountries();
      }
    },
    data: function () {
        return {
            countries: null,
            form: {
                name: "",
                email: "",
                password: "",
                country: "",
                repeatPassword:"",
                lang: "es",
                terms:"",
                recaptcha:"",
                recaptchaError: false,
                accept: false
            },
            options: [
                {
                    value: 'en',
                    text: 'English'
                },
                {
                    value: 'es',
                    text: 'Español'
                },
                {
                    value: 'cz',
                    text: 'Čeština'
                },
                {
                    value: 'de',
                    text: 'Deutsch'
                },
                {
                    value: 'fr',
                    text: 'Français'
                },
                {
                    value: 'it',
                    text: 'Italiano'
                },
                {
                    value: 'nl',
                    text: 'Nederlands'
                },
                {
                    value: 'pt',
                    text: 'Português'
                }
            ],
        }
    },

    validations: {
        form: {
            name: {
                required,
                minLength: minLength(4)
            },
            country: {
                required
            },
            terms: {
                sameAs: sameAs( () => 'true' ),
            },
            email: {
                required,
                email
            },
            password: {
                required,
                minLength: minLength(8),
                maxLength: maxLength(25),
                isPasswordSafe
            },
            repeatPassword: {
                sameAsPassword: sameAs('password')
            }
        }
    },
    methods: {
        setCountries(){
          this.countries = this.countriesList
        },
        callLogin: function () {
            this.$emit('setLogin');
        },
        onCapchaVerify: function (response) {
            this.form.recaptcha = true;
            this.form.recaptchaError= false;
        },
        submit() {
            this.$v.form.$touch();
            if (this.$v.form.$error | !this.form.recaptcha){
                this.form.recaptchaError = true;
                return
            }
           this.signUp();
        },
        signUp: function () {
            fb.auth.createUserWithEmailAndPassword(this.form.email, this.form.password).then(
                (newUser) => {
                    let lang = (this.form.lang) ? this.form.lang : 'es';
                    // Save user data
                    fb.usersCollection.doc(newUser.user.uid).set({
                        id: newUser.user.uid,
                        GDPR: true,
                        name: this.form.name,
                        email:  this.form.email,
                        role: 'maintenance',
                        language: lang,
                        country: this.form.country,
                        company: this.company,
                        pools: [],
                        createdAt: Math.floor(Date.now() / 1000)
                    }).then(() => {
                        // this.sendEmail();
                        this.setLogin();
                    }).catch(err => {
                        this.$emit('onLogout', err.message);
                        this.$emit('onError', err.message);
                    })
                },
                (err) => {
                    this.$emit('onError', err.message);
                }
            );
        },
        setLogin: function () {
            this.$snotify.async(this.$t("messages.login.verifyUser"), () => new Promise((resolve, reject) => {
                fb.auth.signInWithEmailAndPassword(this.form.email, this.form.password).then((current) => {
                    if(current){
                        resolve({
                            body: this.$t("messages.login.userValid"),
                            config: {
                                timeout: 1500,
                                closeOnClick: true
                            }
                        })
                       this.$emit('logged'); 
                    }else{
                        this.$emit('setLogin');
                    }
                }).catch( (err) => {
                    this.$emit('setLogin');
                })
            }))
        },

        showTerms() {
            this.$emit('onShowTerms')
        }
    }
}
</script>

<style>
.modal-detail {
    border-radius: 5px;
    background: #F7F7F7;
    box-shadow: 5px 5px 30px 0px rgba(46,61,73, 0.6);
  }

  .modal-detail-content {
    padding: 10px;
  
  }

</style>


// WEBPACK FOOTER //
// src/components/SignUp.vue